import Empty from '@/views/Empty';
import ReportFiles from '@/views/pages/report/files/Index';
import FileDetail from '@/views/pages/report/files/Detail';
import ReportIndex from '@/views/pages/report/Index';

export default {
  path: 'report',
  component: Empty,
  meta: {},
  children: [
    {
      path: 'files',
      component: Empty,
      children: [
        {
          path: '',
          name: 'Files',
          component: ReportFiles,
        },
        {
          path: ':jobId',
          name: 'File Detail',
          component: FileDetail,
        },
      ],
    },
    {
      path: ':reportName?',
      name: 'Report',
      component: ReportIndex,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/report.js